module Hereabout.UI.Components.ContentComponent where

import Prelude

import Data.Const (Const)
import Data.Maybe (Maybe(..))
import Effect (Effect)
import Effect.Class (class MonadEffect, liftEffect)
import Halogen as H
import Halogen.HTML as HH
import Halogen.HTML.Properties as HP
import Hereabout.Types (Content(..))
import Hereabout.UI.Bulma.Classes as Bulma
import Hereabout.UI.Components.RawHTMLComponent as RawHTMLComp
import Markdown.Markdown (sanitisedHTMLFromContent)
import Type.Proxy (Proxy(..))
import Web.HTML (HTMLElement)


type State = 
  { content :: Content
  }

data Action 
  = InitComponent

type Slot id = forall q o. H.Slot q o id

type ChildSlots =
  ( rawHTMLComp :: RawHTMLComp.Slot Unit
  )

component :: forall o m q. MonadEffect m => H.Component q Content o m
component = 
  H.mkComponent
    { initialState: \c -> { content : c }
    , render
    , eval: H.mkEval H.defaultEval
      { handleAction = handleAction
      , initialize = Just InitComponent
      }
    }

render :: forall m. MonadEffect m => State -> H.ComponentHTML Action ChildSlots m
render state =  
  case state.content of
    ParagraphsContent paras -> 
      HH.div [HP.classes [Bulma.content]] $ map (\p -> HH.p_ $ [HH.text p]) paras
    MarkdownContent mc ->
      HH.div [] []
    HTMLContent htmlC -> HH.slot_ (Proxy :: _ "rawHTMLComp") unit RawHTMLComp.component {html : htmlC}


handleAction :: forall cs o m. MonadEffect m => Action -> H.HalogenM State Action cs o m Unit
handleAction InitComponent = do
  state <- H.get
  case state.content of
    MarkdownContent _ -> do
      html <- liftEffect $ sanitisedHTMLFromContent state.content
      H.modify_ _ { content = html}
    _ -> 
      pure unit